import { render, staticRenderFns } from "./DocumentTemplateDetailPageList.vue?vue&type=template&id=0e2de74c&scoped=true&"
import script from "./DocumentTemplateDetailPageList.vue?vue&type=script&lang=ts&"
export * from "./DocumentTemplateDetailPageList.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentTemplateDetailPageList.vue?vue&type=style&index=0&id=0e2de74c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2de74c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCard,VImg,VSheet})
